// Gestion du slider vertical de miniatures
class ThumbnailSliderVertical {
  constructor(slider) {
    this.slider = slider;
    this.thumbnailList = slider.querySelector('.thumbnail-list');

    if (!this.thumbnailList) return;

    // Désactiver le scroll de la souris
    this.thumbnailList.addEventListener('wheel', (e) => {
      e.preventDefault();
    }, { passive: false });

    // Gérer les clics sur les pseudo-éléments
    this.slider.addEventListener('click', (e) => {
      const rect = this.slider.getBoundingClientRect();
      const clickY = e.clientY - rect.top;

      // Clic sur bouton haut (::before) - 4rem = 40px
      if (clickY < 40 && !this.slider.classList.contains('scroll-at-top')) {
        this.scrollPrev();
      }
      // Clic sur bouton bas (::after) - 4rem = 40px depuis le bas
      else if (clickY > rect.height - 40 && !this.slider.classList.contains('scroll-at-bottom')) {
        this.scrollNext();
      }
    });

    // Mettre à jour l'état au scroll
    this.thumbnailList.addEventListener('scroll', () => {
      this.updateButtonStates();
    });

    // État initial
    this.updateButtonStates();
  }

  scrollPrev() {
    // Scroll d'une miniature vers le haut
    const firstItem = this.thumbnailList.querySelector('.thumbnail-list__item');
    if (!firstItem) return;

    const itemHeight = firstItem.offsetHeight;
    const gap = 4; // 0.4rem = 4px
    const scrollAmount = itemHeight + gap;

    this.thumbnailList.scrollBy({
      top: -scrollAmount,
      behavior: 'smooth'
    });
  }

  scrollNext() {
    // Scroll d'une miniature vers le bas
    const firstItem = this.thumbnailList.querySelector('.thumbnail-list__item');
    if (!firstItem) return;

    const itemHeight = firstItem.offsetHeight;
    const gap = 4; // 0.4rem = 4px
    const scrollAmount = itemHeight + gap;

    this.thumbnailList.scrollBy({
      top: scrollAmount,
      behavior: 'smooth'
    });
  }

  updateButtonStates() {
    const scrollTop = this.thumbnailList.scrollTop;
    const scrollHeight = this.thumbnailList.scrollHeight;
    const clientHeight = this.thumbnailList.clientHeight;

    // Vérifier si en haut (avec marge de 1px pour les arrondis)
    if (scrollTop <= 1) {
      this.slider.classList.add('scroll-at-top');
    } else {
      this.slider.classList.remove('scroll-at-top');
    }

    // Vérifier si en bas (avec marge de 1px pour les arrondis)
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      this.slider.classList.add('scroll-at-bottom');
    } else {
      this.slider.classList.remove('scroll-at-bottom');
    }
  }
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
  const verticalSliders = document.querySelectorAll('.product--thumbnail_slider .thumbnail-slider, .product--thumbnail .thumbnail-slider');

  verticalSliders.forEach(slider => {
    // Vérifier que c'est bien en mode vertical (min-width 750px)
    if (window.innerWidth >= 750) {
      new ThumbnailSliderVertical(slider);
    }
  });
});

// Re-initialiser au resize si on passe au-dessus de 750px
let wasAbove750 = window.innerWidth >= 750;
window.addEventListener('resize', () => {
  const isAbove750 = window.innerWidth >= 750;

  if (isAbove750 && !wasAbove750) {
    const verticalSliders = document.querySelectorAll('.product--thumbnail_slider .thumbnail-slider, .product--thumbnail .thumbnail-slider');
    verticalSliders.forEach(slider => {
      new ThumbnailSliderVertical(slider);
    });
  }

  wasAbove750 = isAbove750;
});
